import angular from 'angular';
import { updateAllStepsComplete, getRedirectUrlPath, setLoading } from '../../actions/page';
import { updatePrimaryEmail } from '../../actions/returnConfirmation';
import s from './StepAsyncLabelCtrl.module.css';
import { orderService } from '../../services/order-service/order-service';
import { store } from '../../store';

angular.module('StepAsyncLabelCtrl', []).controller('StepAsyncLabelController', [
  '$scope',
  '$location',
  '$anchorScroll',
  ($scope, $location, $anchorScroll) => {
    $anchorScroll('top');
    $scope.s = s;
    store.dispatch(setLoading(false));

    const orderInfo = orderService.getOrder();
    if (!orderInfo.order_info) {
      $location.path(store.dispatch(getRedirectUrlPath()));
    }
    store.dispatch(updatePrimaryEmail(orderInfo.order_info.email));
    store.dispatch(updateAllStepsComplete(true));
  },
]);
